import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// LABOUR BASED APPRAISAL VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify LB Object Goals Inbox (GET)
export const getVerifyLBObjectGoals = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            RoleId: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyLBObjectGoals?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get LB Appraisal by ID (GET)
export const getLBAppraisalById = async (params) => {
    try {
        const { id, labourId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!id) {
            throw new Error('ID is required');
        }
        if (!labourId) {
            throw new Error('LabourId is required');
        }
        
        const queryParams = new URLSearchParams({
            Id: id.toString().trim(),
            LabourId: labourId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetLBAppraisalbyId?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};


// 3. Approve LB Objects (PUT)
export const approveLBObjects = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.LabourId) {
            throw new Error('LabourId is required');
        }
        if (!params.Id) {
            throw new Error('Id is required');
        }
        if (!params.RoleId) {
            throw new Error('RoleId is required');
        }
        if (!params.Createdby) {
            throw new Error('Createdby is required');
        }
        if (!params.Action) {
            throw new Error('Action is required');
        }
        
        const payload = {
            LabourId: params.LabourId.toString().trim(),
            Id: parseInt(params.Id),
            Remarks: params.Remarks?.toString().trim() || '',
            Year: params.Year ? parseInt(params.Year) : 0,
            Month: params.Month ? parseInt(params.Month) : 0,
            CCCode: params.CCCode?.toString().trim() || '',
            RoleId: parseInt(params.RoleId),
            Createdby: params.Createdby.toString().trim(),
            Action: params.Action.toString().trim(),
            Note: params.Note?.toString().trim() || ''
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveLBObjects`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};